var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWalmart = function SvgWalmart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E5E5E5",
    rx: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h21v21H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDBB30",
    d: "M15.907 12.733c.469 0 .855-.244.907-.559l.463-5.232c0-.517-.606-.942-1.368-.942-.761 0-1.366.425-1.366.942l.462 5.233c.051.314.437.558.904.558zM13.078 14.367c.236-.405.217-.86-.03-1.063l-4.3-3.017c-.448-.258-1.119.053-1.5.713-.38.659-.313 1.395.133 1.654l4.762 2.217c.298.111.704-.101.937-.507zM18.738 14.365c.235.405.639.617.937.506l4.762-2.217c.448-.259.513-.995.134-1.654-.383-.66-1.054-.971-1.5-.713l-4.301 3.017c-.246.202-.264.658-.03 1.063zM15.907 19.269c.469 0 .855.242.907.557l.463 5.232c0 .518-.606.942-1.368.942-.761 0-1.366-.424-1.366-.942l.462-5.232c.051-.315.437-.557.904-.557zM18.738 17.634c.235-.405.639-.617.937-.504l4.762 2.215c.448.259.513.996.134 1.656-.383.657-1.054.97-1.5.712l-4.301-3.014c-.246-.205-.264-.66-.03-1.065zM13.078 17.634c.236.404.217.86-.03 1.065l-4.3 3.014c-.448.258-1.119-.055-1.5-.712-.38-.66-.313-1.397.133-1.656l4.762-2.215c.298-.113.704.099.937.504z"
  })));
};
export default SvgWalmart;